import PermissionsBase from './permissions-base';

export default class PermissionsMeet extends PermissionsBase {
  compute([level]) {
    return this.permissions.meet(level);
  }
}
